module.exports = __webpack_public_path__ + "img/cake-3.58a53604.svg";